import {useEffect, useRef} from 'react';
import {useAppSelector} from '@/hooks';
import {MODALS_IDS} from '@Components/modal-container';
import {handleMakeTextEditableModalDismissed, isMakeTextEditableConversionPending} from '@Components/ai-chat-window/lib/make-text-editable-growl.library';

/**
 * Hands a running make-text-editable conversion off to a growl when the user closes the loading modal by ANY
 * means — close button, drag-to-dismiss, backdrop, or Escape — all of which flip the modal's `isOpen` to false
 * (the panel's close handler only catches the button, so we watch the redux state instead). Gated on
 * `isMakeTextEditableConversionPending()` so it never fires for the other AI-action loading modals.
 */
export const useMakeTextEditableDismissWatcher = (): void => {
  const isLoadingModalOpen = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.AI_ACTION_LOADING_MODAL]?.isOpen ?? false;
  });
  const wasOpenRef = useRef(false);

  useEffect(() => {
    if (wasOpenRef.current && !isLoadingModalOpen && isMakeTextEditableConversionPending()) {
      handleMakeTextEditableModalDismissed();
    }
    wasOpenRef.current = isLoadingModalOpen;
  }, [isLoadingModalOpen]);
};
